import { Injectable } from '@angular/core';
import { ApiService, ApiPath } from '@eceos/arch';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SupportBankSlip } from './support-bank-slip';
import { SupportGenerateBankSlipRequest } from './support-generate-bank-slip-request';
import { PendingReceivable } from './pending-receivable';
import { SgvJson } from '@eceos/arch';

@Injectable({ providedIn: 'root' })
export class SupportBankSlipsRepository {
  private api: ApiPath;

  constructor(apiService: ApiService) {
    this.api = apiService.root.path('support/bankSlips');
  }

  listAll(): Observable<SupportBankSlip[]> {
    return this.api.getJson<any[]>().pipe(
      map(items => SgvJson.from.array(items, SupportBankSlip.fromJson))
    );
  }

  findById(id: string): Observable<SupportBankSlip> {
    return this.api.path(id).getJson<any>().pipe(
      map(SupportBankSlip.fromJson)
    );
  }

  listPendingReceivables(): Observable<PendingReceivable[]> {
    return this.api.path('pending-receivables').getJson<any[]>().pipe(
      map(items => SgvJson.from.array(items, PendingReceivable.fromJson))
    );
  }

  generate(request: SupportGenerateBankSlipRequest): Observable<SupportBankSlip> {
    return this.api.path('generate').postJson<any>(request.toJson()).pipe(
      map(SupportBankSlip.fromJson)
    );
  }

  regenerate(id: string): Observable<SupportBankSlip> {
    return this.api.path(id).path('regenerate').postJson<any>({}).pipe(
      map(SupportBankSlip.fromJson)
    );
  }
}
